import React from 'react';
import styled from 'styled-components';

export default styled(({ className }) => (
  <svg
    className={className}
    aria-hidden="true"
    focusable="false"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 34 34"
  >
    <path fill="currentColor" d="M22.483 9.442c1.718-.418 3.548.564 3.51 2.502-.055 2.891.004 5.793.004 8.686 0 2.31 5.094 1.27 4.475-.659-.369-1.148-1.775-6.134-2.066-6.935h-.441v-2.593l-3.152-3.157 1.87-1.874 3.928 3.934v3.69h-.406c.316 1.058 1.529 5.11 1.942 6.397 1.454 4.533-7.914 6.246-7.914 1.197 0-2.901-.053-5.816.004-8.713.016-.914-1.2-.968-1.754-.58v13.497h2.14v5.186H1.7v-5.186h2.14V3.74h18.643v5.702zM5.603 24.834H20.72V5.507H5.604v19.327zM8.85 10.52h8.736v-2.09H8.849v2.09zM7.085 12.29h12.264V6.664H7.085v5.625zm1.986 3.64a.87.87 0 1 0 .001 1.738.87.87 0 0 0 0-1.738zm0-1.768a2.636 2.636 0 0 1 2.633 2.637 2.635 2.635 0 0 1-2.633 2.638 2.635 2.635 0 0 1-2.632-2.638 2.635 2.635 0 0 1 2.632-2.637zM3.464 28.253H22.86V26.6H3.464v1.652z" />
  </svg>
))``;
